import type { SortingState } from '@tanstack/react-table';
import { Actions } from '../../components/product-table/columns/actions-column';
import { AvgSalesInterval } from '../../components/product-table/columns/avg-sales-interval-column';
import { DaysOverdue } from '../../components/product-table/columns/days-overdue-column';
import { ExtendedCost } from '../../components/product-table/columns/extended-cost-column';
import { ItemCode } from '../../components/product-table/columns/item-code-column';
import { LastSold } from '../../components/product-table/columns/last-sold-column';
import { ProductNameWithLabels } from '../../components/product-table/columns/product-name-with-labels-column';
import { QOH } from '../../components/product-table/columns/qoh-column';
import { Type } from '../../components/product-table/columns/simple-columns';
import { Size } from '../../components/product-table/columns/size-column';
import { VendorName } from '../../components/product-table/columns/vendor-name-column';
import { DepartmentFilter } from '../../components/product-table/filters/department-filter';
import { FiltersPopover } from '../../components/product-table/filters/filters-popover';
import { HideDisabledFilter } from '../../components/product-table/filters/hide-disabled-filter';
import { TotalValue } from '../../components/product-table/filters/total-value-filter';
import { ProductReport } from '../../components/product-table/product-report';
import type { StrictColumnDef } from '../../components/tanstack-table/column';
import type { Product } from '../../data/product';
import type { Filters } from '../../hooks/products';
import { productReportsLayout } from '../../router';

const columns: StrictColumnDef<Product>[] = [
  VendorName,
  ItemCode,
  ProductNameWithLabels,
  Type,
  Size,
  LastSold,
  AvgSalesInterval,
  DaysOverdue,
  QOH,
  ExtendedCost,
  Actions,
];

const sorting: SortingState = [{ id: DaysOverdue.id, desc: true }];

const defaultFilters: Filters = {
  minimumInventory: 1,
  hideDisabled: true,
  stockingIssue: true,
};

export function StockingIssuesReport() {
  const products = productReportsLayout.useLoaderData();

  return (
    <ProductReport
      products={products}
      title="Possible Stocking Issues"
      defaultFilters={defaultFilters}
      columns={columns}
      sorting={sorting}
      toolbarLeft={
        <FiltersPopover defaultFilters={defaultFilters}>
          <HideDisabledFilter />
          <DepartmentFilter products={products} />
        </FiltersPopover>
      }
      toolbarRight={<TotalValue />}
    />
  );
}
